module.exports = __webpack_public_path__ + "static/media/slide-mobile (4).91b1fc32.jpg";